module.exports = __webpack_public_path__ + "img/upvip2.00f443c8.png";